import { getHTML, getText } from '@amzn/awscat-editor';
import { decode } from 'html-entities';

export function formatTaskDescriptionColumn(html: string): string {
  const toRemoveString = [
    '<strong>|<\/strong>|<em>|<\/em>|<pre>|<ol>|<\/ol>|<ul>|<\/ul>|<li>|<hr>|',
    '<span class="fr-class-code">|<\/span>|<\/a>|<br>|',
    '<code>|</code>|',
    '<ol style="list-style-type: lower-alpha;">|',
    '<ol style="list-style-type: lower-greek;">|',
    '<ol style="list-style-type: lower-roman;">|',
    '<ol style="list-style-type: upper-alpha;">|',
    '<ol style="list-style-type: upper-roman;">|',
    '<ul style="list-style-type: circle;">|',
    '<ul style="list-style-type: disc;">|',
    '<ul style="list-style-type: square;">',
  ].join('');
  const toRemove = new RegExp(toRemoveString, 'g');
  const inlineStyle = /(<span style='.*?;'>)|(<span style=".*?;">)/g;
  const paragraph = /<p>|(<\/p>)|(<\/pre>)|(<\/li>)/g;
  const toSpace = /&nbsp;/g;
  const apostrophe = /&#39;/g;
  const linkStart = /<a href="/g;
  const linkEnd = /" rel="noopener noreferrer" target="_blank">|">/g;
  const extraLine = /\r\r/g;
  const htmlTiptap = decode(getHTML(html));
  return htmlTiptap
    .trim()
    .replace(toRemove, '')
    .replace(inlineStyle, '')
    .replace(toSpace, ' ')
    .replace(apostrophe, "'")
    .replace(linkStart, '[')
    .replace(linkEnd, ']')
    .replace(paragraph, '\r')
    .replace(extraLine, '\r')
    .trim();
}

export function formatEpicsAndTasks(value: any): string {
  const textValue = getText(value);
  return textValue;
}
